module.exports = __webpack_public_path__ + "img/boky_81_sharp-zelena.34c7fbda.png";